import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import {SaleVehicleRegistrationRequestBody} from '@dms/api/vehicle';
import {SaleVehicle} from '@dms/features/vehicle-forms-kit';

type RegistrationFormValues = Pick<
  SaleVehicle,
  | 'salePresetId'
  | 'vehicleSourceCodeId'
  | 'warrantyProgramId'
  | 'warrantyDuration'
  | 'qualitySealKey'
  | 'isQualitySealManualOverride'
>;

// TO_BUY for purchase business cases (referrer is BC with purchaseType query param),
// FOR_SALE otherwise (sale BC, interest, or no referrer)
// Without a Sale program, a null seal is never a manual choice — only a non-null one is. The
// manual mark deliberately survives make and vehicle-type changes, which clear the key on their
// own, so submitting the pair unfiltered would send an explicit "none" the user never picked and
// stop the backend from applying the Sale program's default for the new make.
const isExplicitQualitySealSelection = (values: RegistrationFormValues) =>
  values.isQualitySealManualOverride === true &&
  (isNotNil(values.qualitySealKey) || isNotNil(values.salePresetId));

export const buildRegistrationPayload = (
  values: RegistrationFormValues,
  isBusinessCasePurchaseReferrer: boolean,
  isQualitySealShown: boolean
): SaleVehicleRegistrationRequestBody =>
  match(isBusinessCasePurchaseReferrer)
    .with(
      true,
      (): SaleVehicleRegistrationRequestBody => ({
        type: 'TO_BUY',
        salePresetId: values.salePresetId,
        vehicleSourceCodeId: values.vehicleSourceCodeId,
      })
    )
    .otherwise(
      (): SaleVehicleRegistrationRequestBody => ({
        type: 'FOR_SALE',
        salePresetId: values.salePresetId,
        vehicleSourceCodeId: values.vehicleSourceCodeId,
        warrantyProgramId: values.warrantyProgramId,
        warrantyDuration: values.warrantyDuration,
        ...(isQualitySealShown &&
          isExplicitQualitySealSelection(values) && {
            qualitySealKey: values.qualitySealKey ?? null,
          }),
      })
    );
